import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import { Units, Colors } from 'Css';
import FormFieldContainer from '../FormFieldContainer';
import { TagSelector } from 'components/Tags';
import { DropDown } from 'components/DropDown';
import classNames from 'classnames';

const css = oxygenCss({
  root: {},
  panel: {
    padding: Units.base
  },
  half: {
    width: 96
  },
  row: {
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    display: 'flex'
  },
  title: {
    color: Colors.text.Light.secondary,
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: '0.3px',
    marginBottom: Units.base * 2
  },
  list: {
    width: 96,
    cursor: 'pointer',
    '&selected': {
      '>DIV': {
        borderColor: Colors.creen
      }
    },
    ':hover': {
      '>DIV': {
        backgroundColor: '#404040'
      }
    },
    '>DIV': {
      boxSizing: 'border-box',
      height: Units.base * 2,
      border: 'solid 2px #535353',
      margin: Units.base / 2
    }
  },
  grid: {
    width: 96,
    cursor: 'pointer',
    '&selected': {
      '>DIV': {
        borderColor: Colors.creen
      }
    },
    ':hover': {
      '>DIV': {
        backgroundColor: '#404040'
      }
    },
    '>DIV': {
      boxSizing: 'border-box',
      width: Units.base * 3,
      height: Units.base * 3 - 2,
      display: 'inline-block',
      border: 'solid 2px #535353',
      margin: Units.base / 4
    }
  }
});

class StoreListModuleEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    filter: PropTypes.object,
    mode: PropTypes.oneOf(['grid', 'list', 'cards']),
    categories: PropTypes.array
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  addTag = tagName => {
    const { id, filter } = this.props;
    const tags = (filter && filter.tags) || {};
    StoreOverviewActions.updateModule(id, {
      filter: {
        ...filter,
        tags: {
          ...tags,
          [tagName]: true
        }
      }
    });
  };

  removeTag = tagName => {
    const { id, filter } = this.props;
    const tags = (filter && filter.tags) || {};
    StoreOverviewActions.updateModule(id, {
      filter: {
        ...filter,
        tags: {
          ...tags,
          [tagName]: false
        }
      }
    });
  };

  handleCategoryChange = categoryId => {
    const { id, filter } = this.props;
    StoreOverviewActions.updateModule(id, {
      filter: {
        ...filter,
        categoryId
      }
    });
  };

  gridMode = () => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      mode: 'grid'
    });
  };

  listMode = () => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      mode: 'list'
    });
  };

  cardsMode = () => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      mode: 'cards'
    });
  };

  render() {
    const { filter, categories } = this.props;
    const mode = this.props.mode || 'grid';
    // const { tags } = filter;
    const tags = (filter && filter.tags) || {};
    const categoryId = (filter && filter.categoryId) || null;
    const { getIntlMessage } = this.context;
    const menuItems = [
      { payload: null, label: getIntlMessage('store.chooseCategory') },
      ...categories.map(category => ({
        payload: category.slug,
        label: category.label
      }))
    ];

    return (
      <div>
        <div className={css.panel}>
          <div className={css.row}>
            <div className={css.half}>
              <FormFieldContainer title={getIntlMessage('store.smallCards')}>
                <div
                  onTouchTap={this.gridMode}
                  className={classNames(css.grid, {
                    [css.selected]: mode === 'grid'
                  })}
                >
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </FormFieldContainer>
            </div>
            <div className={css.half}>
              <FormFieldContainer title={getIntlMessage('store.bigCards')}>
                <div
                  onTouchTap={this.cardsMode}
                  className={classNames(css.grid, {
                    [css.selected]: mode === 'cards'
                  })}
                >
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </FormFieldContainer>
            </div>

            <div className={css.half}>
              <FormFieldContainer title={getIntlMessage('store.list')}>
                <div
                  onTouchTap={this.listMode}
                  className={classNames(css.list, {
                    [css.selected]: mode === 'list'
                  })}
                >
                  <div />
                  <div />
                  <div />
                </div>
              </FormFieldContainer>
            </div>
          </div>
          <div className={css.title}>
            {getIntlMessage('store.showOnlyMatching')}
          </div>
          <FormFieldContainer title={getIntlMessage('Tags')} leftAlign>
            <TagSelector
              dark
              fullWidth
              tags={tags}
              onAddTag={this.addTag}
              onRemoveTag={this.removeTag}
            />
          </FormFieldContainer>
          <FormFieldContainer
            title={getIntlMessage('course.category')}
            leftAlign
          >
            <DropDown
              fullWidth
              dark
              onChange={this.handleCategoryChange}
              options={menuItems}
              selected={categoryId}
            />
          </FormFieldContainer>
        </div>
      </div>
    );
  }
}

export default StoreListModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/Modules/StoreListModuleEditor.js